import React, { useEffect } from 'react';
import tippy from 'tippy.js'; // Import Tippy.js
import { useNavigate } from "react-router-dom"; // Import useHistory from react-router-dom
import { message } from "antd";
import 'tippy.js/dist/tippy.css'; // Import Tippy.js styles

const AdminHeader = () => {
    const navigate = useNavigate();
    useEffect(() => {
        // Initialize Tippy.js tooltip for the signout button
        tippy('.signout-button', {
            content: 'Signout',
            placement: 'bottom',
        });
    }, []);

    return (
        <div className="bg-primary dark:bg-bg-dark flex justify-between items-center px-4">

            {/*    <img
                    src={logo}
                    alt="logo"
                    className="h-20 rotate-2 p-3 hover:cursor-pointer"
                />
            </Link> */}

            <p className='py-5 px-2 font-semibold cursor-pointer text-white'>Admin Panel </p>

            {/* Add a class for the Signout button */}
            <button className='mx-4 signout-button' onClick={() => {
                localStorage.removeItem("token");
                message.warning("Sign Out");
                navigate("/login");

            }}>
                <i className="ri-logout-circle-r-line text-white text-2xl"></i>
            </button>
        </div>
    );
};

export default AdminHeader;
